import React from 'react';

export const TextPreview = ({ component, onClick, isSelected }) => {
  const { commonAttrs, specificAttrs } = component;
  
  const style = {
    padding: `${commonAttrs.paddingTop}px ${commonAttrs.paddingRight}px ${commonAttrs.paddingBottom}px ${commonAttrs.paddingLeft}px`,
    margin: `${commonAttrs.marginTop}px ${commonAttrs.marginRight}px ${commonAttrs.marginBottom}px ${commonAttrs.marginLeft}px`,
    fontSize: `${specificAttrs.fontSize}px`,
    fontWeight: specificAttrs.fontWeight,
    lineHeight: specificAttrs.lineHeight,
    textAlign: specificAttrs.textAlign,
    color: specificAttrs.color,
    fontFamily: specificAttrs.fontFamily,
    cursor: 'pointer',
    border: isSelected ? '2px solid #3B82F6' : '2px solid transparent',
    borderRadius: '4px'
  };

  return (
    <div style={style} onClick={onClick}>
      {specificAttrs.content || 'Text content'}
    </div>
  );
};
